import { render, staticRenderFns } from "./RecursosHumanos.vue?vue&type=template&id=57e31dde&"
import script from "./RecursosHumanos.vue?vue&type=script&lang=js&"
export * from "./RecursosHumanos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports